export type AppConsentResult = "TRACK" | "DO_NOT_TRACK";
export type AppSiteContext = "app-ios" | "app-android" | "browser-desktop" | "browser-mobile";
export type AppPlatform = "ios" | "android";

export const APP_CONSENT_STORAGE_KEY = "app:tracking_consent";
export const APP_SITE_CONTEXT_STORAGE_KEY = "app:site_context";
export const APP_PLATFORM_STORAGE_KEY = "app:platform";


export function isAppPlatform(value: string | null): value is AppPlatform {
    return value === "ios" || value === "android";
}

export function getStoredAppPlatform(): AppPlatform | null {
    try {
        const raw = localStorage.getItem(APP_PLATFORM_STORAGE_KEY);
        return isAppPlatform(raw) ? raw : null;
    } catch {
        return null;
    }
}

export function isAppConsentResult(value: string | null): value is AppConsentResult {
    return value === "TRACK" || value === "DO_NOT_TRACK";
}

export function isAppSiteContext(value: string | null): value is AppSiteContext {
    return value === "app-ios" ||
        value === "app-android" ||
        value === "browser-desktop" ||
        value === "browser-mobile";
}

export function getStoredAppConsent(): AppConsentResult | null {
    try {
        const raw = localStorage.getItem(APP_CONSENT_STORAGE_KEY);
        return isAppConsentResult(raw) ? raw : null;
    } catch {
        return null;
    }
}

export function getStoredAppSiteContext(): AppSiteContext | null {
    try {
        const raw = localStorage.getItem(APP_SITE_CONTEXT_STORAGE_KEY);
        return isAppSiteContext(raw) ? raw : null;
    } catch {
        return null;
    }
}